import { render, staticRenderFns } from "./bankAccounts.vue?vue&type=template&id=a6441cdc&scoped=true&"
import script from "./bankAccounts.vue?vue&type=script&lang=ts&"
export * from "./bankAccounts.vue?vue&type=script&lang=ts&"
import style1 from "./bankAccounts.vue?vue&type=style&index=1&id=a6441cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6441cdc",
  null
  
)

export default component.exports